module.exports = __webpack_public_path__ + "img/20210619_171635.11f60327.jpg";